import React from 'react'
import container from './container'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Form, Spin, Card, Input, Button, Space } from 'antd'

const HotelCoverageSearch = props => {
    const { $props, $loading, $fieldProps, canCreate, onCreate } = props
    return (
        <Spin spinning={$loading}>
            <Form colon={false} {...$props}>
                <Card
                    title="Hotel Coverage"
                    size="small"
                    extra={
                        <Space>
                            {canCreate ? (
                                <Button onClick={() => onCreate()}>
                                    <PlusOutlined /> New hotel
                                </Button>
                            ) : null}
                            <Button htmlType={'submit'} type="primary">
                                <SearchOutlined /> Find
                            </Button>
                        </Space>
                    }>
                    <div className="d-md-flex align-items-center">
                        <Card.Meta description="One hotel_mapping_provider row: which supplier catalogs map the hotel, and which hotel_mapping_v2 regions search reaches it through." />
                    </div>
                    <br />
                    <Form.Item name={'hotel_id'} wrapperCol={{ flex: 1 }} {...$fieldProps.hotel_id}>
                        <Input placeholder="Enter a hotel_id (2151861)" />
                    </Form.Item>
                </Card>
            </Form>
        </Spin>
    )
}

export default container(HotelCoverageSearch)
